import { Pagination } from './common'

/**
 * 用户类型定义
 */
export class User {
  id = 0
  username = ''
  email = ''
  phone = ''
  role: 'user' | 'admin' | 'super' = 'user'
  status: 'active' | 'inactive' = 'active'
  height = 0
  weight = 0
  created_at = ''
  last_login = ''
}

/**
 * 用户列表接口
 */
export interface UserItem {
  id: string | number, // 唯一标识符
  name: string  // 账号名称
  phone: string  // 手机
  email:string // 邮箱
  gender:string // 性别
  height:string | number // 身高
  weight:string | number // 体重
  role: string // 账号角色
  isOpen:boolean, // 是否开启账号
  create_time: string // 创建时间
  update_time: string // 更新时间
}

/**
 * 用户角色枚举
 */
export enum UserRole {
  USER = 'user',
  ADMIN = 'admin', 
  SUPER = 'super'
}

/**
 * 用户状态枚举
 */
export enum UserStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive'
}

/**
 * 管理员用户列表项接口
 */
export interface AdminUserItem {
  id: number
  name: string
  email: string
  phone?: string
  role: 'user' | 'admin' | 'super'
  status: 'active' | 'inactive'
  height?: number
  weight?: number
  created_at: string
  last_login?: string
  device_count?: number
  task_count?: number
  total_count?: number
}

/**
 * 用户列表查询参数
 */
export interface UserListParams {
  page?: number
  limit?: number
  search?: string
  role?: 'user' | 'admin' | 'super'
  status?: 'active' | 'inactive'
  start_date?: string
  end_date?: string
}

/**
 * 分页结果类型
 */
export interface PagedResult<T> {
  total: number
  totalPages?: number
  currentPage?: number
  [key: string]: any
}

export enum ActivityErrType {
  All = 0,
  Success = 1,
  Error = -1,
}
export namespace ActivityErrType {
  export const getString = (deleteFlag: ActivityErrType): string => {
    switch (deleteFlag) {
      case ActivityErrType.All:
        return '所有'
      case ActivityErrType.Success:
        return '成功'
      case ActivityErrType.Error:
        return '失败'
    }
  }
}

export class GetActivitiesReq extends Pagination {
  userIds: number[] = []
  apiResourceId = 0
  errSelect = {
    all: ActivityErrType.All,
    some: [] as number[],
  }

  timeAfter = 0
}

export class Activity {
  userId = 0
  username = ''
  activityId = ''
  errCode = 0
  createTimeMs = 0
  displayGroup = ''
  displayMember = ''
  displayDescription = ''
  apiResourceId = 107
  url = ''
  // options: Record<string, string> = {}
}
